const FontStyle = `
<style>

            .utility-font-1 {
                font-family:  GT-America-Standard-Regular;
                font-size: 10px;
                font-style: normal;
                font-weight: 400;
                line-height: 18px;
                letter-spacing: 0.1px;
            }
            .cta-text {
                font-family: GT-America-Standard-Regular;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 26px;
                letter-spacing: 0.28px;
                text-transform: uppercase;
            }
            .title-font-3 {
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                -webkit-text-size-adjust: 100%;
                -ms-text-size-adjust: 100%;
                font-weight: 400;
                font-family: Spectral-ExtraLight, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
                font-size: 50px;
                line-height: 54px;
                letter-spacing: -1px;
            }


            .title-font-5 {
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                -webkit-text-size-adjust: 100%;
                -ms-text-size-adjust: 100%;
                font-weight: 400;
                font-family: Spectral-ExtraLight, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
                font-size: 38px;
                line-height: 40px;
                letter-spacing: -.38px;
            }
            .title-font-7 {
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                -webkit-text-size-adjust: 100%;
                -ms-text-size-adjust: 100%;
                font-weight: 400;
                font-family: Spectral-ExtraLight, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
                font-size: 28px;
                line-height: 30px;
                letter-spacing: -.28px;
            }
            .title-font-9 {
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                -webkit-text-size-adjust: 100%;
                -ms-text-size-adjust: 100%;
                font-weight: 400;
                font-family: GT-America-Standard-Regular, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
                font-size: 18px;
                line-height: 28px;
                letter-spacing: .54px;
            }
            .title-font-11 {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    font-weight: 400;
    font-family: GT-America-Standard-Regular, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 14px;
    line-height: normal;
    letter-spacing: .42px;
}
            .title-font-15 {
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                -webkit-text-size-adjust: 100%;
                -ms-text-size-adjust: 100%;
                font-weight: 400;
                font-family: Spectral-ExtraLightItalic, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
                font-size: 38px;
                line-height: 40px;
                letter-spacing: -1px;
            }
            .body-font-1 {
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                -webkit-text-size-adjust: 100%;
                -ms-text-size-adjust: 100%;
                font-weight: 400;
                font-family: GT-America-Standard-Regular, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
                font-size: 14px;
                line-height: 20px;
                letter-spacing: .28px;
            }



            .body-font-2 {
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                -webkit-text-size-adjust: 100%;
                -ms-text-size-adjust: 100%;
                font-weight: 400;
                font-family: GT-America-Standard-Regular, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
                font-size: 12px;
                line-height: 18px;
                letter-spacing: .12px;
            }

            .body-font-4 {
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                -webkit-text-size-adjust: 100%;
                -ms-text-size-adjust: 100%;
                font-weight: 400;
                font-family: GT-America-Condensed-Medium, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
                font-size: 14px;
                line-height: 20px;
                letter-spacing: 2.24px;
                text-transform: uppercase;
            }
            .body-font-5 {
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                -webkit-text-size-adjust: 100%;
                -ms-text-size-adjust: 100%;
                font-weight: 400;
                font-family: GT-America-Condensed-Regular, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
                font-size: 12px;
                line-height: 18px;
                letter-spacing: 1.92px;
                text-transform: uppercase;
            }

            @media screen and (min-width: 1025px) {
                .title-font-3 {
                    font-size: 62px;
                    line-height: 64px;
                    letter-spacing: -1.86px;
                }
                .title-font-5 {
                    font-size: 50px;
                    line-height: 54px;
                    letter-spacing: -1px;
                }
                .title-font-9 {
                    font-size: 24px;
                    line-height: 36px;
                    letter-spacing: .72px;
                }
                    .title-font-11 {
        font-size: 18px;
        line-height: 28px;
        letter-spacing: .54px;
    }
                .title-font-15 {
                    font-size: 50px;
                    line-height: 54px;
                    letter-spacing: -1.86px;
                }
                .body-font-1 {
                    font-size: 16px;
                    line-height: 24px;
                    letter-spacing: .32px;
                }
                .body-font-2 {
                    font-size: 14px;
                    line-height: 20px;
                    letter-spacing: .28px;
                }
                .body-font-4 {
                    font-size: 16px;
                    line-height: 22px;
                    letter-spacing: 3.2px;
                }
                .body-font-5 {
                    font-size: 14px;
                    line-height: 20px;
                    letter-spacing: 2.8px;
                }

            }



             .button-text-font {
                font-family:  GT-America-Standard-Regular;
                font-size: 10px;
                font-style: normal;
                font-weight: 400;
                line-height: 18px; /* 180% */
                letter-spacing: 0.1px;
            }

            .dash {
                border-bottom: 1px solid;
                width: 27px;
                height: 1px;
                display: inline-block;
                margin: 0 6px
            }

    .cta {
        font-weight: 400;
        font-family: GT-America-Standard-Regular, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
        font-size: 14px;
        letter-spacing: .28px;
        text-align: center;
        text-transform: uppercase;
        height: 40px;
        line-height: 38px;
        border: 1px solid;
        outline: 1px solid transparent;
        padding: 4px 24px;
        border-radius: 11px;
        display: flex !important;
        align-items: center;
        justify-content: center;
        -webkit-transition: background .45s, color .45s, border .45s;
        box-sizing: border-box;
        cursor: pointer;
        text-decoration: none;
    }

    .cta-1 {
        color: #c3c7c7;
        background: #000;
        border-color: transparent;
    }

    .cta-2 {
        color: #000;
        background: #fff;
        border-color: transparent;
    }

    .cta-3 {
        color: #000;
        background: transparent;
        border-color: transparent;
    }

    .cta-4 {
        background-color: rgb(138, 229, 211);
        color: rgb(0, 0, 0) ;
        transition: none ;
        border-color: transparent;
    }

    .cta-link-1 {
        display: flex !important;
        align-items: center;
        color: #000;
        border: none;
    }

    @media screen and (min-width: 1025px) {
        .cta {
            max-width: 300px;
        }
    }



</style>
`;
const ButtonStyles = `
  <style>
  .cta-1 {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    background: transparent;
    background: #000;
    border: 1px solid transparent;
    border-radius: 11px;
    color: #c3c7c7;
    font-family: GT-America-Standard-Regular, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
    font-weight: 400;
    height: 40px;
    line-height: 26px;
    line-height: 38px;
    outline: 1px solid transparent;
    padding: 4px 24px;
    text-align: center;
    text-transform: uppercase;
    transition: background .45s, color .45s, border .45s;
    -moz-transition: background .45s, color .45s, border .45s;
    -webkit-transition: background .45s, color .45s, border .45s;
    -ms-transition: background .45s, color .45s, border .45s;
    -o-transition: background .45s, color .45s, border .45s;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .cta-link-1 {
    display: flex !important;
    align-items: center;
    color: #000;
    border: none;
  }

  .cta-1:hover {
    background-color: #d2eae5;
    border-color: #d2eae5;
    color: #000;
  }

  .cta-2:hover {
      background-color: #d2eae5;
      border-color: #d2eae5;
      color: #000;
    }

  .cta-link-1:hover {
      background-color: #d2eae5;
      border-color: #d2eae5;
      color: #000;
  }

  .cta-1:disabled {
  background-color: grey;
  }

  .dash {
  border-bottom: 1px solid;
    display: inline-block;
    height: 1px;
    margin: 4px 6px;
    width: 27px;
  }

</style>
`;
export { FontStyle, ButtonStyles };
